import React from 'react';

const Banner = () => {
    return (
       <div>
            <div className='text-center py-8 text-3xl font-bold'>
                <h1>Promotes</h1>
            </div>
            <img src="https://res.cloudinary.com/dkxt6mlnh/image/upload/v1715693998/ta/tfohwr0b93k82g389azl.png" alt="banner" className='mx-auto' width="30%" />
       </div>
    );
};

export default Banner;